<router-outlet></router-outlet>
<div [ngClass]="{'pre-loader': g.loaderDisplay === 'display'}"></div>
